/**
 * Whether the app is running in development (always the opposite of import.meta.env.PROD). See
 * https://vite.dev/guide/env-and-mode.html#built-in-constants.
 */
export function isDevServer(): boolean {
  return import.meta.env.DEV;
}

/**
 * Whether the app is running in production (running the dev server with NODE_ENV='production' or
 * running an app built with NODE_ENV='production'). See
 * https://vite.dev/guide/env-and-mode.html#built-in-constants.
 */
export function isProductionBuild(): boolean {
  return import.meta.env.PROD;
}

export function consoleWarnInDevelopmentModeOnly(...params: Parameters<typeof console.warn>): void {
  if (!isProductionBuild() && process.env.NODE_ENV !== "test") {
    console.warn("%c[Development warning]", "font-weight: bold; color: #E0A04C", ...params);
  }
}
